import { render } from "./ListsPage.vue?vue&type=template&id=a66689f0&scoped=true"
import script from "./ListsPage.vue?vue&type=script&lang=js"
export * from "./ListsPage.vue?vue&type=script&lang=js"

import "./ListsPage.vue?vue&type=style&index=0&id=a66689f0&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a66689f0"]])

export default __exports__